import {queueParams} from '@/utils/ap/queue-params';
import service from '@/services/ap-review';
import {apError} from '@/utils/ap/commands';
export function createAPQueueModule(api=service) {
    let sequence=0;let cancel=null;
    const initial=()=>({context:null,epoch:0,page:null,stats:null,loading:false,error:null});
    return {
        namespaced:true,state:initial,
        mutations:{reset(state,context=null) {const epoch=state.epoch+1;Object.assign(state,initial(),{context,epoch});},loading(state,value) {state.loading=value;},result(state,{page,stats}) {state.page=page;state.stats=stats;},error(state,error) {state.error=error;}},
        actions:{
            open({commit},context) {cancel?.cancel();sequence++;commit('reset',context);},
            clear({commit}) {cancel?.cancel();sequence++;commit('reset');},
            async load({state,commit},filters={}) {
                if(!state.context) return;
                const token=++sequence;const epoch=state.epoch;cancel?.cancel();cancel=api.cancelSource?.();const current=()=>token===sequence && epoch===state.epoch;
                commit('loading',true);commit('error',null);commit('result',{page:null,stats:null});
                try {const params={...queueParams(filters),limit:Math.min(100,Number(filters.limit)||50),offset:Math.max(0,Number(filters.offset)||0)};
                const {limit,offset,ordering,...statsParams}=params; // Stats use exactly the same business filters, without pagination.
                const [page,stats]=await Promise.all([api.queue(params,cancel?.token),api.stats(statsParams,cancel?.token)]);if(current()) commit('result',{page,stats});}
                catch(error) {if(current()) {commit('result',{page:null,stats:null});commit('error',apError(error));}}
                finally {if(current()) commit('loading',false);}
            },
        },
    };
}
export default createAPQueueModule();
